import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { beSendCheckoutReceiptEmail } from 'actions/checkout/beSendCheckoutReceiptEmail.action';
import { feCleanCheckoutData } from 'actions/ui.actions';
import validateEmail from 'bl/validation/validateEmail.bl';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import Space from 'components/generic/Space.component';
import SM from 'components/sidebar/appointment/wizard/Wizard.module.scss';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonOpeningHours } from 'selectors/currentSalon.selectors';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import { formatYearToDayCompact } from 'utils/date/format.util';
import { formatSchedulerWeekUrlSegment, getSchedulerWeekStartMonday } from 'utils/date/schedulerWeekBound.util';
import navFor from 'utils/links/navFor.util';

import { cleanTransactionData, fetchClient, getAppointment, sendEmail } from 'checkout/actions';
import Email from 'checkout/components/Email';
import { setView } from 'scheduler/actions';

import CN from './SendReceiptAfterCheckout.module.scss';

class SendReceiptAfterCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      emailEdited: false,
      invalidEmail: false,
      emailTemplate: false,
      isSendingReceipt: false,
      hasError: false,
      isEmailSent: false,
      isNewEmail: false,
      dayView: true,
      selectedDate: moment(),
      showDatePicker: false,
      hasConfirmedEmailSave: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.history.location.pathname.includes('/week/')) {
      this.setState({ dayView: false });
    }
  }

  componentDidMount() {
    const clients = this.props.transaction?.response?.clients;
    if (clients?.length === 1 && clients[0]?.id) {
      this.props.getClient({ id: clients[0].id, salon_id: this.props.salonId });
      setTimeout(() => {
        for (let i = 0; i < this.props.appointments.length; i += 1) {
          this.props.getAppointment(this.props.salonId, this.props.appointments[i]);
        }
      }, 1000);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.client && nextProps?.transaction?.response?.clients && nextProps.client.id === nextProps.transaction.response.clients[0].id) {
      this.setState({ email: nextProps.client.email });
    }
  }

  onEmailChange = (event) => {
    const value = event.target.value;
    this.setState({ email: value, emailEdited: true, hasError: false });

    const valid = validateEmail({ value });
    this.setState({ invalidEmail: !valid });
  };

  sendReceiptToEmail = async () => {
    const { email, invalidEmail, isSendingReceipt } = this.state;
    const { t } = this.props;

    if (invalidEmail || !email || isSendingReceipt) return;

    // TODO: delete this when the API is ready
    this.setState({ emailTemplate: true }, () => {
      const receipt = document.getElementById('receipt');

      if (receipt && this.props.transaction.response.id) {
        this.props.sendEmail(
          this.props.transaction.response.id,
          email,
          t('checkout.sendReceipt.receiptFrom', {
            name: this.props.salonDetails.name,
          }),
          receipt.outerHTML,
          t('checkout.sendReceipt.emailHTMLSupport'),
        );

        const confirmEmailSave = this.props.data.clients.length === 1 && this.state.emailEdited;

        this.setState({
          emailTemplate: false,
          isEmailSent: !confirmEmailSave, // success without confirmation flow
          isNewEmail: confirmEmailSave,
        });
      }

      // TODO: uncomment this when the API is ready
      // const transactionId = this.props.transaction.response?.id;
      // if (!transactionId) return;

      // this.setState({ isSendingReceipt: true, hasError: false });

      // try {
      //   const result = await beSendCheckoutReceiptEmail({ transactionId, clientEmail: email });

      //   if (result?.is?.ok !== true) {
      //     this.setState({ isSendingReceipt: false, hasError: true });
      //     return;
      //   }

      //   const confirmEmailSave = data.clients.length === 1 && this.state.emailEdited;

      //   this.setState({
      //     isSendingReceipt: false,
      //     isEmailSent: !confirmEmailSave,
      //     isNewEmail: confirmEmailSave,
      //     hasError: false,
      //   });
      // } catch (e) {
      //   this.setState({ isSendingReceipt: false, hasError: true });
      // }
    });
  };

  close = () => {
    this.props.cleanTransactionData();

    const { salonId, history, openingHours, match } = this.props;
    const { stylistId } = match.params;
    const nav = navFor('SendReceiptAfterCheckout.close()', { history });
    const currentDate = moment();
    const isWeekView = !this.state.dayView && stylistId && history.location.pathname.includes('/week/');
    const url = isWeekView ? `/salon/${salonId}/week/${formatSchedulerWeekUrlSegment(currentDate)}/${stylistId}` : `/salon/${salonId}/day/${formatYearToDayCompact(currentDate)}`;

    if (isWeekView) {
      const weekStart = getSchedulerWeekStartMonday(currentDate);
      this.props.setView(false, weekStart, stylistId, openingHours);
    }
    nav.push(url);
  };

  updateClientEmail = () => {
    if (this.props.data.clients[0]?.id) {
      this.props.updateClient({
        id: this.props.data.clients[0].id,
        email: this.state.email,
        salon_id: this.props.salonId,
      });
    }

    this.setState({
      isNewEmail: false,
      isEmailSent: true,
      hasConfirmedEmailSave: true,
    });
  };

  render() {
    const { id: transactionId } = this.props.transaction.response || {};
    const { isNewEmail, isEmailSent, invalidEmail, emailTemplate, email, isSendingReceipt, hasError } = this.state;
    const { salonDetails, client, t } = this.props;

    const hasClientEmail = fromAnyToString(client?.email);

    return (
      <div data-bem="SendReceiptAfterCheckout">
        {emailTemplate && transactionId && <Email clients={this.props.data.clients} data={this.props.transaction.response} vouchers_used={this.props.data.vouchers_used} salonDetails={salonDetails} />}
        <SalonModal tag="SendReceiptAfterCheckout__checkout" isOpen={!isEmailSent} withFooter>
          <SalonModal.Header>
            <div className={SM.closeButtonContainer}>
              <Button variant="empty" onClick={this.close}>
                <Icon variant="close" variantInvert />
              </Button>
            </div>
          </SalonModal.Header>
          <SalonModal.Body>
            <IconStatus variant="info" width="lg">
              <Icon variant="envelope" width="l1" />
            </IconStatus>
            <div className={SM.modalContent}>
              <div className={SM.modalTitle}>{isNewEmail ? t('checkout.sendReceipt.title1') : t('checkout.sendReceipt.title2')}</div>

              <div className={SM.modalText}>
                {hasClientEmail ? (
                  email
                ) : (
                  <>
                    <input type="text" placeholder={t('checkout.sendReceipt.emailPlaceholder')} value={fromAnyToString(email)} onChange={this.onEmailChange} autoComplete="off" />
                    {invalidEmail && <div className={SM.error}>{t('checkout.sendReceipt.emailValidationError')}</div>}
                  </>
                )}
              </div>

              {isNewEmail && <div className={CN.emailMessage}>{t('checkout.sendReceipt.saveEmailMsg')}</div>}
              {fromAnyToBool(hasError) && <div className={SM.error}>{t('checkout.sendReceipt.sendFailed')}</div>}
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            {isNewEmail ? (
              <>
                <Button variant="outlineForce" onClick={() => this.setState({ isNewEmail: false, isEmailSent: true })} xSpace>
                  {t('common.buttons.no')}
                </Button>
                <Button variant="primaryForce" onClick={this.updateClientEmail} xSpace>
                  {t('common.buttons.yes')}
                </Button>
              </>
            ) : (
              <Button variant="primaryForce" onClick={this.sendReceiptToEmail} disabled={isSendingReceipt} xSpace>
                {t('checkout.sendReceipt.sendReceiptButton')}
              </Button>
            )}
          </SalonModal.Footer>
        </SalonModal>

        <SalonModal tag="SendReceiptAfterCheckout__success" isOpen={isEmailSent} variant="noFooter">
          <SalonModal.Header>
            <div className={SM.closeButtonContainer}>
              <Button variant="empty" onClick={this.close}>
                <Icon variant="close" variantInvert />
              </Button>
            </div>
          </SalonModal.Header>

          <SalonModal.Body>
            <IconStatus variant="success" width="lg">
              <Icon variant="confirm" width="xl" />
            </IconStatus>

            <div className={SM.modalContent}>
              <div className={SM.modalTitle}>{t('checkout.sendReceipt.receiptSent')}</div>
              <div className={SM.modalText}>
                {t('checkout.sendReceipt.successfullySentMsg')} <Space bold>{email}</Space>
              </div>
            </div>
          </SalonModal.Body>
        </SalonModal>
      </div>
    );
  }
}

const SendReceiptAfterCheckoutHoc = connect(
  (state) => ({
    salonId: state?.currentSalon?.id,
    data: state?.checkout?.data,
    client: state?.checkout?.edit_client?.data,
    isFetching: state?.checkout?.edit_client?.isFetching,
    transaction: state?.transaction?.create,
    salonDetails: state?.currentSalon,
    appointments: state?.checkout?.appointments,
    initialAppointment: state?.checkout?.initialAppointment,
    openingHours: selectCurrentSalonOpeningHours(state),
  }),
  mapActionsToDispatchToProps({
    setView,
    sendEmail,
    beSendCheckoutReceiptEmail,
    cleanTransactionData,
    feCleanCheckoutData,
    getClient: (data) => fetchClient(data?.salon_id, data, 'GET'),
    updateClient: (data) => fetchClient(data?.salon_id, data, 'PUT'),
    getAppointment,
  }),
)(withTranslation()(SendReceiptAfterCheckout));

// this extra export is needed for tests that provide their own mock for connect()
export { SendReceiptAfterCheckout as SendReceiptAfterCheckout4Test };

export default SendReceiptAfterCheckoutHoc;
